/** 车主信息 
 *  创建时间：2017-03-30 
 *  创建人：zhanlz
 */
<template>
	<div class="pl10px pr10px" v-loading="loadingstatus" element-loading-text="加载中">
		<div class="form-horizontal">
			<div class="form-group">
				<label class="col-sm-1 control-label t_center">车主ID</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" readonly v-model="ownerInfo.id">
				</div>
				<label class="col-sm-1 control-label t_center red">车主类型</label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': $v.ownerInfo.customerType.$error }">
					<select class="form-control" v-model="ownerInfo.customerType" @input="$v.ownerInfo.customerType.$touch()">
						<option v-for="option in customerTypes" v-bind:value="option.udccode">
							{{ option.udcname }}
						</option>
					</select>
					<span class="form-group__message cus_message" v-if="!$v.ownerInfo.customerType.required && $v.ownerInfo.customerType.$error">车主类型为必填项</span>
				</div>
				<label class="col-sm-1 control-label t_center red">车主名称</label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': $v.ownerInfo.ownerName.$error }">
					<input type="text" class="form-control"  v-model.trim="ownerInfo.ownerName" maxlength="10" @input="$v.ownerInfo.ownerName.$touch()">
					<span class="form-group__message cus_message" v-if="!$v.ownerInfo.ownerName.required && $v.ownerInfo.ownerName.$error">车主名称为必填项</span>
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label t_center red">证件类型</label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': $v.ownerInfo.certificatesType.$error }">
					<select class="form-control" v-model="ownerInfo.certificatesType" @input="$v.ownerInfo.certificatesType.$touch()">
						<option v-for="option in certificatesTypes" v-bind:value="option.udccode">
							{{ option.udcname }}
						</option>
					</select>
					<span class="form-group__message cus_message" v-if="!$v.ownerInfo.certificatesType.required && $v.ownerInfo.certificatesType.$error">证件类型为必填项</span>
				</div>
				<label class="col-sm-1 control-label t_center red">证件号码</label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': $v.ownerInfo.identifyNo.$error }">
					<input type="text" class="form-control"  v-model.trim="ownerInfo.identifyNo" @input="$v.ownerInfo.identifyNo.$touch()" maxlength="18">
					<span class="form-group__message cus_message" v-if="!$v.ownerInfo.identifyNo.required && $v.ownerInfo.identifyNo.$error">证件号码为必填项</span>
				</div>
				<label class="col-sm-1 control-label t_center red">联系电话1</label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': $v.ownerInfo.phone.$error }">
					<input type="text" class="form-control"  v-model.trim="ownerInfo.phone" maxlength="11">
					<span class="form-group__message cus_message" v-if="!$v.ownerInfo.phone.required && $v.ownerInfo.phone.$error">联系电话1为必填项</span>
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label t_center">联系电话2</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model.trim="ownerInfo.phone2" maxlength="11">
				</div>
				<label class="col-sm-1 control-label t_center red">电子邮箱</label>
				<div class="col-sm-3" v-bind:class="{ 'form-group--error': $v.ownerInfo.email.$error }">
					<input type="text" class="form-control"  v-model.trim="ownerInfo.email" @input="$v.ownerInfo.email.$touch()" maxlength="20">
					<span class="form-group__message cus_message" v-if="!$v.ownerInfo.email.required && $v.ownerInfo.email.$error">电子邮箱为必填项</span>
					<span class="cus_message form-group__message" v-if="!$v.ownerInfo.email.email && $v.ownerInfo.email.$error">您的邮箱格式不正确</span>
				</div>
				<label class="col-sm-1 control-label t_center">QQ</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model.trim="ownerInfo.bindQq" maxlength="13">
				</div>
			</div>
			<div class="form-group">
				<span class="col-sm-offset-1 red" v-if="normalMail && $v.ownerInfo.email.email && $v.ownerInfo.email.required">为确保您能正常接收邮件，请将邮箱（ op_support@didi-gps.com）加入您的邮箱白名单</span>
				<a class="col-sm-offset-1 red" v-if="!normalMail && $v.ownerInfo.email.email && $v.ownerInfo.email.required" :href="mailLink" target="_blank" style="text-decoration: underline;">为确保您能正常接收邮件，请点击将邮箱（ op_support@didi-gps.com）加入白名单</a>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label t_center">联系地址</label>
				<div class="col-sm-11">
					<input type="text" class="form-control" readonly v-model="ownerInfo.address">
				</div>
			</div>
		</div>
		
		<div class="form-horizontal ibox-content">
			<br />
			<div class="form-group">
				<label class="col-sm-1 control-label t_center">联系人1</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model.trim="ownerInfo.linkMan1" maxlength="10">
				</div>
				<label class="col-sm-1 control-label t_center">联系方式</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model.trim="ownerInfo.linkPhone1" maxlength="11">
				</div>
				<label class="col-sm-1 control-label t_center">与车主关系</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model.trim="ownerInfo.relationMan1" maxlength="10">
				</div>
			</div>
			<div class="form-group">
				<label class="col-sm-1 control-label t_center">联系人2</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model.trim="ownerInfo.linkMan2" maxlength="11">
				</div>
				<label class="col-sm-1 control-label t_center">联系方式</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model.trim="ownerInfo.linkPhone2" maxlength="10">
				</div>
				<label class="col-sm-1 control-label t_center">与车主关系</label>
				<div class="col-sm-3">
					<input type="text" class="form-control" v-model.trim="ownerInfo.relationMan2" maxlength="10">
				</div>
			</div>
		</div>
		<div class="form-horizontal">
			<br />
			<div class="form-group">
				<label class="col-sm-1 control-label t_center">工作备注</label>
				<textarea rows="6" class="col-sm-11" v-model="ownerInfo.memo" maxlength="255"></textarea>
			</div>
			<div class="form-group t_center">
				<div class="col-sm-10">
					<button v-if="permission.indexOf('carFileList_vehicleOwnerSave') == -1" class="btn btn-primary" @click="ensureSave" :disabled="!enableSubmit">保存车主信息</button>
				</div>
				<div class="text-right">
					<button v-if="permission.indexOf('carFileList_vehicleOwnerResetPassword') == -1" class="btn btn-primary" @click="sendEmail">重置车主查询密码</button>
				</div>
			</div>
		</div>
		
		<!--   弹出框子组件        -->
		<tab-modal ref="modalMsg" size="small" :scroll='scrollTop' title="提示" v-on:cancel="closeModal">
			{{messageStr}}
			<div slot="footer">
				<button class="btn btn-primary" @click="closeModal">取消</button>
		        <button class="btn btn-primary" @click="saveInfo">确定</button>
		    </div>
		</tab-modal>
		
	</div>
</template>
<script>

	import { OPERATE_EXCEPTION, INFO_EMPTY,SAVE_ENSURE,OPERATE_SUCCESS,SEND_SUCCESS } from 'static/message'
	import TabModal from 'components/common/TabModal'
	import {DICTIONARY_MAP} from 'static/constant'
	import { required,email } from 'vuelidate/lib/validators'
	import {getDictionaryFromArray} from 'util/util'
	import classlist from 'util/classlist'
	
	export default {
		name: 'DetailOwner',
		components: {
		   TabModal
		},
		data() {
			return {
				permission:this.$store.state.permission.permission["carFileList"]?this.$store.state.permission.permission["carFileList"]:[],
				loadingstatus:false,
				vehicleInfo: {},
				ownerInfo: {
					address: "",
		            bindQq: "",
		            identifyNo: "",
		            certificatesType: '',
		            certificatesTypeName:"",
		            createName: "",
		            createTime: "",
		            customerType: '',
		            customerTypeName:"",
		            email: "",
		            id: '',
		            linkMan1: "",
		            linkMan2: "",
		            linkPhone1: "",
		            linkPhone2: "",
		            memo: "",
		            ownerName: "",
		            phone: "",
		            phone2: "",
		            relationMan1: "",
		            relationMan2: "",
		            updateName: "",
		            updateTime: "",
				},
				udcType:[
				DICTIONARY_MAP.CUSTOMERTYPE,
				DICTIONARY_MAP.CERTIFICATESTYPE
				],
				customerTypes:[],
				certificatesTypes:[],
				scrollTop: "0px",
				messageStr:"",
				mailLink:'',            //根据邮箱类型给出不同跳转链接
				normalMail:false        //是否是非163  sina qq邮箱以外的邮箱
			}
		},
		validations: {
			ownerInfo:{
				customerType:{
					required
				},
				certificatesType:{
					required
				},
				ownerName:{
					required
				},
				identifyNo:{
					required
				},
				phone:{
					required
				},
				email:{
					required,
					email
				}
			}
		},
		computed: {
			enableSubmit: function(){
				return this.$v.ownerInfo.customerType.required && this.$v.ownerInfo.certificatesType.required 
				&& this.$v.ownerInfo.ownerName.required && this.$v.ownerInfo.identifyNo.required
				&& this.$v.ownerInfo.phone.required && this.$v.ownerInfo.email.required && this.$v.ownerInfo.email.email;
			}
		},
		watch:{
			'ownerInfo.email'(val){
				let str = val.substring(val.indexOf('@'))
				if(/(@163.com)$/.test(str) || /(@126.com)$/.test(str)){
					this.normalMail = false
					this.mailLink = 'http://help.mail.163.com/faqDetail.do?code=d7a5dc8471cd0c0e8b4b8f4f8e49998b374173cfe9171305fa1ce630d7f67ac28e86c6b6ec2acd66'
					return
				}else if(/(@sina.com)$/.test(str)){
					this.normalMail = false
					this.mailLink = 'http://mail.sina.com.cn/help2/2008-08-02-86.html'
					return
				}else if(/(@qq.com)$/.test(str)){
					this.normalMail = false
					this.mailLink = 'http://service.mail.qq.com/cgi-bin/help?subtype=1&no=113&id=16'
					return
				}else{
					this.normalMail = true
					this.mailLink = 'javascript(void)'
					return
				}
			}
		},
		beforeMount(){
			Object.assign(this.vehicleInfo, this.$parent.vehicleInfo); 
			this.getUdc();	
			console.log()
		},	
		methods:{
			// 获取车主信息
			getOwnerInfo(){
				this.$http.get(process.env.API_ROOT + "/vehicle/vehicles/" + this.vehicleInfo.vehicleId + "/vehicle-owner")
				.then( res => {
					if(res.data.success){								
							this.ownerInfo = res.data.data;
					} else {
						this.$parent.openModal(res.data.message);
					}
					this.loadingstatus = false;
				}, res => {
					this.$parent.openModal(res.data.message)
					this.loadingstatus = false;
				}).catch( res => {
					this.$parent.openModal(OPERATE_EXCEPTION)
					this.loadingstatus = false;
				})
			},
			saveInfo(){//保存基本信息
				this.loadingstatus = true;
				this.$refs.modalMsg.close();
				let subObj = {};
				$.extend(subObj,this.ownerInfo);
				subObj.customerTypeName = this.ownerInfo.customerType;
				subObj.certificatesTypeName = this.ownerInfo.certificatesType;
				this.$http.put(process.env.API_ROOT + "/vehicle/vehicles/" + this.vehicleInfo.vehicleId + "/vehicle-owner", subObj)
				.then( res => {
					if(res.data.success){
						this.closeModal();
						this.$parent.openModal(OPERATE_SUCCESS);
						this.getOwnerInfo();
					} else {
						this.$parent.openModal(res.data.message);
					}
					this.loadingstatus = false;
				}, res => {
					this.$parent.openModal(res.data.message)
					this.loadingstatus = false;
				}).catch( res => {
					this.$parent.openModal(OPERATE_EXCEPTION)
					this.loadingstatus = false;
				})
			},
			//发送邮箱重置密码
			sendEmail(){
				let params = {
					vehicleId:this.vehicleInfo.vehicleId
				};
				this.$http.post(process.env.API_ROOT + "/vehicle/vehicles/password/email", params)
				.then( res => {
					if(res.data.success){
						this.$parent.openModal(SEND_SUCCESS);
					} else {
						this.$parent.openModal(res.data.message);
					}
				}, res => {
					this.$parent.openModal(res.data.message)
				}).catch( res => {
					this.$parent.openModal(OPERATE_EXCEPTION)
				})
			},
			getUdc(){
				this.loadingstatus = true;
				if(this.udcType.length ==0) return;			
				let param = this.udcType.join(',');
				this.$http.get(process.env.API_ROOT + '/system/udcs',{params:{udcTypes: param}})
				.then(res => {
					if(res.data.success){		
						//this.allUdc = this.data.data;
					 	this.customerTypes = getDictionaryFromArray(res.data.data,DICTIONARY_MAP.CUSTOMERTYPE);
						this.certificatesTypes = getDictionaryFromArray(res.data.data,DICTIONARY_MAP.CERTIFICATESTYPE);
						this.getOwnerInfo();
					}else{
						this.$parent.openModal(res.data.message);
						this.loadingstatus = false;
					}
				}, res => {
					this.$parent.openModal(res.data.message);
					this.loadingstatus = false;
				}).catch( res => {
					this.$parent.openModal(OPERATE_EXCEPTION);
					this.loadingstatus = false;
				})		
			},
			closeModal() {
				this.$refs.modalMsg.close();	
				classlist.toggleScroll('open','#carfile-detail',this);
			},
			ensureSave(){
				this.messageStr=SAVE_ENSURE;
				this.$refs.modalMsg.open();
				classlist.toggleScroll('close','#carfile-detail',this);
			},
		}
	}
</script>


// WEBPACK FOOTER //
// DetailOwner.vue?1f243d75